import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../../api/api";

export default function LegalEntityListPage() {
    const [entities, setEntities] = useState([]);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        load();
    }, []);

    const load = async () => {
        try {
            const { data } = await api.get("/LegalEntity/all");
            setEntities(data);
        } catch (err) {
            setError("Failed to load legal entities");
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <p>Loading...</p>;
    if (error) return <p className="text-red-600">{error}</p>;

    return (
        <div className="p-6 bg-white rounded shadow">
            <div className="flex justify-between mb-4">
                <h2 className="text-xl font-bold">Legal Entities</h2>

                <button
                    onClick={() => navigate("/admin/legal/create")}
                    className="bg-indigo-600 text-white px-4 py-2 rounded"
                >
                    Create
                </button>
            </div>

            {entities.map(e => (
                <div key={e.id} className="border p-3 mb-2 rounded">
                    <p><b>{e.companyName}</b></p>
                    <p>TaxId: {e.taxId}</p>
                    <div className="flex gap-2 mt-2">
                        <button
                            onClick={() => navigate(`/admin/legal/${e.id}`)}
                            className="text-green-600"
                        >
                            View
                        </button>

                        <button
                            onClick={() => navigate(`/admin/legal/update/${e.id}`)}
                            className="text-blue-600"
                        >
                            Edit
                        </button>

                        <button
                            onClick={() => navigate(`/admin/legal/delete/${e.id}`)}
                            className="text-red-600"
                        >
                            Delete
                        </button>
                    </div>
                </div>
            ))}
        </div>
    );
}